import {
  CHANGE_IP_MODAL_FIELD,
  CHANGE_SEARCH_INPUT,
  CHANGE_SELECTED_ITEMS,
  CHANGE_WITHIN_LAST_DAYS,
  CLEAR_ALL_FILTERS,
  CREATE_IP_RANGE_ASYNC,
  DEFAULT_IP_MODAL_DATA,
  DELETE_IP_RANGE_ASYNC,
  GET_IP_RANGE_LIST_ASYNC,
  SET_IP_MODAL_DATA,
  UPDATE_IP_RANGE_ASYNC,
  WITHIN_LAST_DAYS_VALUES,
} from './constants'

export default function () {
  const initialState = {
    ipRangeListData: {
      loader: false,
      error: null,
      items: [],
      search: '',
      withinLastDays: WITHIN_LAST_DAYS_VALUES.LAST_180_DAYS,
      selectedItems: [],
    },
    ipModalData: DEFAULT_IP_MODAL_DATA,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case GET_IP_RANGE_LIST_ASYNC.INITIATE:
        return {
          ...state,
          ipRangeListData: {
            ...state.ipRangeListData,
            loader: true,
            error: null,
            items: [],
          },
        }
      case GET_IP_RANGE_LIST_ASYNC.SUCCESS:
        return {
          ...state,
          ipRangeListData: {
            ...state.ipRangeListData,
            loader: false,
            error: null,
            items: action.payload.data.items.map((item) => ({
              ...item,
              rawValues: item.rawValues.split(','),
              isApplyForPastCampaigns: item.applyForPastCampaigns,
            })),
          },
        }
      case GET_IP_RANGE_LIST_ASYNC.ERROR:
        return {
          ...state,
          ipRangeListData: {
            ...state.ipRangeListData,
            loader: false,
            error: action.error,
          },
        }
      case CHANGE_SEARCH_INPUT:
        return {
          ...state,
          ipRangeListData: {
            ...state.ipRangeListData,
            loader: true,
            error: null,
            items: [],
            search: action.payload.value,
          },
        }
      case CHANGE_WITHIN_LAST_DAYS:
        return {
          ...state,
          ipRangeListData: { ...state.ipRangeListData, withinLastDays: action.payload.value },
        }
      case CLEAR_ALL_FILTERS:
        return {
          ...state,
          ipRangeListData: {
            ...state.ipRangeListData,
            withinLastDays: WITHIN_LAST_DAYS_VALUES.LAST_180_DAYS,
            search: '',
          },
        }
      case CHANGE_SELECTED_ITEMS:
        return {
          ...state,
          ipRangeListData: {
            ...state.ipRangeListData,
            selectedItems: action.payload.value,
            error: null,
          },
        }
      case CHANGE_IP_MODAL_FIELD:
        return {
          ...state,
          ipModalData: { ...state.ipModalData, [action.payload.field]: action.payload.value },
        }
      case CREATE_IP_RANGE_ASYNC.INITIATE:
      case UPDATE_IP_RANGE_ASYNC.INITIATE:
      case DELETE_IP_RANGE_ASYNC.INITIATE:
        return {
          ...state,
          ipModalData: { ...state.ipModalData, error: null, loader: true },
        }
      case CREATE_IP_RANGE_ASYNC.SUCCESS:
      case UPDATE_IP_RANGE_ASYNC.SUCCESS:
      case DELETE_IP_RANGE_ASYNC.SUCCESS:
        return {
          ...state,
          ipModalData: { ...state.ipModalData, loader: false },
          ipRangeListData: {
            ...state.ipRangeListData,
            selectedItems: [],
          },
        }
      case CREATE_IP_RANGE_ASYNC.ERROR:
      case UPDATE_IP_RANGE_ASYNC.ERROR:
      case DELETE_IP_RANGE_ASYNC.ERROR:
        return {
          ...state,
          ipModalData: {
            ...state.ipModalData,
            loader: false,
            error: action.error,
          },
        }
      // case DELETE_IP_RANGE_ASYNC.INITIATE:
      //   return {
      //     ...state,
      //     ipModalData: { ...state.ipModalData, loader: true },
      //   }
      case SET_IP_MODAL_DATA:
        return {
          ...state,
          ipModalData: { ...state.ipModalData, ...action.payload.data },
        }
      default:
        return state
    }
  }
}
